import React, { memo } from 'react';
import { BodyText, RadioButton } from '@swift-paypal/pp-react';
import { Field } from 'redux-form';
import PropTypes from 'prop-types';

// eslint-disable-next-line react/prop-types
const MappedInput = ({ input, ...props }) => <RadioButton {...input} {...props} />;

const RadioField = ({
  label, error, touched, ...props
}) => (
  <>
    {label && (
      <BodyText as="label">
        {label}
      </BodyText>
    )}
    <Field
      errorText={touched && error}
      component={MappedInput}
      {...props}
    />
  </>
);

RadioField.propTypes = {
  label: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
  error: PropTypes.string,
  touched: PropTypes.bool,
};

RadioField.defaultProps = {
  label: undefined,
  error: undefined,
  touched: false,
};

export default memo(RadioField);
